<div class="wxrl-rule-detail__top">
  <afoone-breadcrumb
    [backUrl]="'/wxrl/rules'"
    [breadcrumbItems]="[
      {
        label: 'WXRL.LIST_RULES',
        route: '/wxrl/rules',
      },
      {
        label: 'WXRL.RULE_DETAIL',
      }
    ]"
  ></afoone-breadcrumb>
</div>

<div *ngIf="editMode" class="edit-mode-banner">
    {{ "WXRL.EDIT_MODE.BANNER" | translate }}
</div>

<p-card
  *ngIf="rule || isNewRule"
  class="rule-detail"
>
  <ng-template pTemplate="header">
    <div class="rule-detail-card-header">
      <span class="rule-detail-card-header__title">{{ ruleDetailCardHeader }}</span>
      <afoone-wxrl-authors
        class="rule-detail-authors"
        [createdBy]="author"
        [createdWhen]="rule?.createdWhen"
        [modifiedBy]="modified"
        [modifiedWhen]="modifiedWhen"
      ></afoone-wxrl-authors>
    </div>
  </ng-template>

  <!--main data -->
  <div class="container">
    <div class="rule-options-container">
      <div class="ids" *ngIf="!editMode">
        <div class="field">
          <label for="id">ID</label>
          <!-- Keep ngModel for navigation dropdown - it's outside the form -->
          <p-dropdown
            id="id"
            [options]="ruleNrs"
            [ngModel]="rule?.ruleNr"
            [showClear]="false"
            (ngModelChange)="onRuleNrChange($event)"
            [lazy]="true"
            class="w-small"
          />
        </div>
        <!-- navigation -->
        <div class="navigation">
          <p-button
            icon="pi pi-angle-double-left"
            (click)="onFirstRule()"
            severity="warn"
            [disabled]="!hasPreviousRule"
          ></p-button>
          <p-button
            icon="pi pi-angle-left"
            (click)="onPreviousRule()"
            [disabled]="!hasPreviousRule"
          ></p-button>
          <p-button
            icon="pi pi-angle-right"
            (click)="onNextRule()"
            [disabled]="!hasNextRule"
          ></p-button>
          <p-button
            icon="pi pi-angle-double-right"
            (click)="onLastRule()"
            [disabled]="!hasNextRule"
          ></p-button>
        </div>
      </div>

      <!-- Botón Editar Regla -->
      <div *ngIf="canEditThisRule && !editMode" class="button-container">
        <p-button
          [label]="'EDIT' | translate"
          [icon]="editMode ? 'pi pi-times' : 'pi pi-pencil'"
          [severity]="editMode ? 'warn' : 'primary'"
          (click)="toggleEditMode()"
          size="small"
        ></p-button>
      </div>

      <!-- Guardar + Cancelar (misma fila en edición; evitar doble clic mientras guarda) -->
      <div
        *ngIf="canEditThisRule && editMode"
        class="button-container wxrl-rule-detail-save-row"
      >
        <p-button
          label="Guardar"
          icon="pi pi-check"
          severity="success"
          [disabled]="ruleForm.invalid || savingRule"
          [loading]="savingRule"
          (click)="onSave()"
          size="small"
        ></p-button>
        <p-button
          *ngIf="!isNewRule"
          [label]="'WXRL.EDIT_MODE.CANCEL_EDIT' | translate"
          icon="pi pi-times"
          severity="secondary"
          [disabled]="savingRule"
          (click)="onCancelEdit()"
          size="small"
        ></p-button>
      </div>
    </div>

    <!-- Form group starts here -->
    <div class="rule-info" [formGroup]="ruleForm">
      <div class="row">
        <div class="field">
          <label for="descripcion">{{
            "WXRL.RULE.DESCRIPCION" | translate
          }}</label>
          <input
            id="descripcion"
            type="text"
            pInputText
            formControlName="ruleName"
            [readonly]="!editMode"
          />
        </div>
        <div class="field">
          <label for="abreviatura">{{
            "WXRL.RULE.FORM.ABREVIATURA" | translate
          }}</label>
          <input
            id="abreviatura"
            type="text"
            pInputText
            formControlName="ruleKrz"
            class="wxrl-rule-krz-input"
            maxlength="10"
            [readonly]="!editMode"
          />
        </div>
      </div>
      <div class="row">
        <div class="field">
          <label for="comentario">{{
            "WXRL.RULE.FORM.COMENTARIO" | translate
          }}</label>
          <input
            id="comentario"
            type="text"
            pInputText
            formControlName="kommentar"
            [readonly]="!editMode"
            class="w-full"
          />
        </div>
      </div>
      <div class="row">
        <div class="field">
          <label for="formula">{{
            "WXRL.RULE.FORM.FORMULA" | translate
          }}</label>
          <afoone-wxrl-formula-editor
            id="formula"
            formControlName="condition"
            [conditions]="getConditionsForFormulaEditor()"
            [interactionLocked]="
              (!editMode && !isNewRule) ||
              ruleForm.get('directExecution')?.value === true
            "
            class="w-full"
          ></afoone-wxrl-formula-editor>
          <small
            class="p-error"
            *ngIf="
              editMode &&
              ruleForm.hasError('formulaRequiredUnlessDirect') &&
              (ruleForm.get('condition')?.dirty ||
                ruleForm.get('directExecution')?.dirty)
            "
            >{{ "WXRL.RULE.FORM.NO_CONDITIONS_RULE_ERROR_EMPTY" | translate }}</small
          >
        </div>
        <div class="field">
          <p-checkbox
            [label]="'WXRL.RULE.FORM.NEGADA' | translate"
            formControlName="negRule"
            [binary]="true"
          ></p-checkbox>
        </div>
        <div class="field">
          <p-checkbox
            [label]="'WXRL.RULE.FORM.NO_CONDITIONS_RULE' | translate"
            formControlName="directExecution"
            [binary]="true"
            [pTooltip]="'WXRL.RULE.FORM.NO_CONDITIONS_RULE_TOOLTIP' | translate"
            tooltipPosition="top"
          ></p-checkbox>
        </div>
      </div>

      <div class="row" *ngIf="!isNewRule">
        <div class="field" style="flex: auto">
          <label style="font-size: 10px">Nº Evaluaciones</label>
          <input pInputText readonly [value]="rule?.execCount ?? 0" />
        </div>
        <div class="field">
          <label style="min-width: 80px; font-size: 10px">Nº Ejecuciones</label>
          <input pInputText readonly [value]="rule?.execCountAction ?? 0" />
        </div>
        <div class="field">
          <label style="min-width: 80px; font-size: 10px">Cumplimiento</label>
          <input pInputText readonly [value]="cumplimiento" />
        </div>
        <div class="field">
          <label style="min-width: 50px; font-size: 10px">Desde</label>
          <input
            type="text"
            pInputText
            readonly
            [value]="rule?.dateCount ?? ''"
            style="min-width: 110px"
          />
        </div>
        <div class="field">
          <label>&nbsp;</label>
          <p-button
            [label]="'WXRL.RULE.RESET_COUNTER' | translate"
            icon="pi pi-refresh"
            [disabled]="!canResetCounters"
            (onClick)="onResetCounters()"
          ></p-button>
        </div>
      </div>
    </div>
  </div>

  <p-tabView [(activeIndex)]="activeTabIndex">
    <p-tabPanel *ngIf="!isNewRule" [header]="'WXRL.RULE.TABS.SUMMARY' | translate">
      <afoone-wxrl-summary [rule]="rule"></afoone-wxrl-summary>
    </p-tabPanel>
    <p-tabPanel [header]="'WXRL.RULE.TABS.SCHEMA' | translate">
      <afoone-wxrl-schema
        [rule]="rule"
        [conditionsFormArray]="conditionsFormArray"
        [actionsFormArray]="actionsFormArray"
        [triggersFormArray]="triggersFormArray"
        [canEdit]="canEditSchema"
        [ruleForm]="ruleForm"
        [labNr]="isNewRule ? labNr : (rule?.actionHeader?.labNr ?? labNr)"
        [labType]="labType"
        [isNewRule]="isNewRule"
        (newRuleFirstAccessAbandon)="onNewRuleFirstAccessAbandon()"
      ></afoone-wxrl-schema>
    </p-tabPanel>
    <p-tabPanel [header]="'WXRL.RULE.TABS.CONDITIONS' | translate">
      <afoone-wxrl-conditions-list
        [conditionsFormArray]="conditionsFormArray"
        [canEdit]="canEditSchema"
      ></afoone-wxrl-conditions-list>
    </p-tabPanel>
    <p-tabPanel [header]="'WXRL.RULE.TABS.ACTIONS' | translate">
      <afoone-wxrl-rule-actions
        [actionsFormArray]="actionsFormArray"
        [canEdit]="canEditSchema"
        [actionHeader]="rule?.actionHeader"
        [actionStates]="actionStates"
      ></afoone-wxrl-rule-actions>
    </p-tabPanel>
    <p-tabPanel [header]="'WXRL.RULE.TABS.TRIGGERS' | translate">
      <afoone-wxrl-rule-triggers
        [triggersFormArray]="triggersFormArray"
        [canEdit]="canEditSchema"
      ></afoone-wxrl-rule-triggers>
    </p-tabPanel>
    <p-tabPanel [header]="'WXRL.RULE.TABS.LOGS' | translate">
      <afoone-wxrl-rule-logs [rule]="rule"></afoone-wxrl-rule-logs>
    </p-tabPanel>
  </p-tabView>
</p-card>

<p-confirmDialog></p-confirmDialog>
